import React from 'react'
import Provider from './Provider'
import { Section, SectionHeader, Reveal, AsyncResponsesLoading, DidYouKnowPageDisplay } from 'components'
import { Grid, Box, useMediaQuery } from '@material-ui/core'
import { IProps, ISnapshotViewProps } from './Interface'
import { useStyles } from './Styles'
import { theme } from 'config/constants/theme/theme'

const SnapshotPage: React.FC<ISnapshotViewProps> = ({ state, publicMode }) => {
  const classes = useStyles({})
  const mdSize = useMediaQuery(theme.breakpoints.down('md'))
  const sectionPadding = mdSize ? '20px 10px' : '30px 50px 30px'
  const borderRadius = publicMode
    ? { topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0 }
    : { topLeft: 0, topRight: 0 }

  return (
    <Grid container direction={'column'} className={classes.container}>
      <SectionHeader
        name={state.user?.firstName}
        currentLocation={state.user?.residence}
        hometownLocation={state.hometownLocation}
        beans={state.responseBeans}
      />
      {!mdSize && (
        <Section size={{}} borderRadius={borderRadius} padding={sectionPadding} direction={'column'}>
          {!publicMode && (
            <Box mb={8}>
              <DidYouKnowPageDisplay
                embeddedPage={true}
                projectToLife={state.projectToLife}
                funFact={state.funFact}
                statNum={state.statNum}
                statDetail={state.statDetail}
                randomJob={state.randomJob}
                uniqueInterest={state.uniqueInterest}
                tedTalk={state.tedTalk}
              />
            </Box>
          )}
          <Grid item>
            <Reveal
              firstName={state.user?.firstName}
              lastName={state.user?.lastName}
              school={state.school}
              job={state.jobDescription}
              avatar={state.user?.avatar}
            />
          </Grid>
        </Section>
      )}
    </Grid>
  )
}

export default (props: IProps) => (
  <AsyncResponsesLoading>
    <Provider {...props}>
      {({ state, responses, publicMode }) => (
        <SnapshotPage state={state} responses={responses} publicMode={publicMode} />
      )}
    </Provider>
  </AsyncResponsesLoading>
)
